import { Pipe, PipeTransform, inject } from "@angular/core";
import { CurrencyPipe } from "@angular/common";

/**
 * This pipes purpose is to transform negative values `-` in currency to be displayed as:
 *
 * ($123) instead of -$123
 *
 * In order to hide the decimals, pass in the value after the customCurrency...
 * {{ row.example | customCurrency: true }}
 */
@Pipe({
  name: "customCurrency",
  standalone: true
})
export class CustomCurrencyPipe implements PipeTransform {
  private currencyPipe = inject(CurrencyPipe);

  transform(value: number, hideDecimals?: boolean): string {
    const newCurrency: string = this.currencyPipe.transform(value, "USD", "symbol", hideDecimals ? "1.0-0" : undefined);

    if (newCurrency && value < 0) {
      return "(" + newCurrency.substring(1, newCurrency.length) + ")";
    }

    return newCurrency;
  }
}
